// extracted by mini-css-extract-plugin
export default {"video-canvas":"lsf-video-canvas","video-canvas__view":"lsf-video-canvas__view","video-canvas__toolbar":"lsf-video-canvas__toolbar","video-canvas__loading":"lsf-video-canvas__loading","video-canvas__buffering":"lsf-video-canvas__buffering","buffering":"lsf-buffering","spinner":"lsf-spinner","spin":"lsf-spin","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630385604
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  